import { fromJS } from 'immutable';
const action = name => `/posts/${name}`;

export const GET_POSTS_DATA = action('GET_POSTS_DATA');
export const GET_POSTS_DATA_SUCCESS = action('GET_POSTS_DATA_SUCCESS');

export const getPosts = data => ({ type: GET_POSTS_DATA, data });
export const successPostsData = data => ({ type: GET_POSTS_DATA_SUCCESS, data });

export const UPDATE_POST_DATA = action('UPDATE_POST_DATA');
export const DELETE_POST = action('DELETE_POST');
export const DELETE_BULK_POST_DATA = action('DELETE_BULK_POST_DATA');

export const deleteBulkPost = data => ({ type: DELETE_BULK_POST_DATA, data });
export const updatePost = data => ({ type: UPDATE_POST_DATA, data });
export const deletePostData = data => ({ type: DELETE_POST, data });

const initialState = fromJS({

});

const posts = (state = initialState, action) => {
  switch (action.type) {
    case GET_POSTS_DATA_SUCCESS:
      return state.set('postData', action.data);
    default:
      return state;
  }
};

export default posts;


// WEBPACK FOOTER //
// ./src/ducks/post.js